/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 24/12/2021
 */

import OAuthToken from "@shared/integrations/OAuthToken";
import {Type} from "class-transformer";
import GoogleCalendarItem from "@shared/integrations/calendar/GoogleCalendarItem";
import OutlookCalendarItem from "@shared/integrations/calendar/OutlookCalendarItem";
import iCalCalendarItem from "@shared/integrations/calendar/iCalCalendarItem";
import StaticIdObject from "@shared/StaticIdObject";


export default class CalendarIntegrations extends StaticIdObject{

	@Type(() => GoogleCalendarItem)
	gCalendarItemsArray: GoogleCalendarItem[] = []

	@Type(() => OutlookCalendarItem)
	outlook365ItemsArray: OutlookCalendarItem[] = []

	@Type(() => iCalCalendarItem)
	iCalItemsArray: iCalCalendarItem[] = []



	//@Deprecated
	@Type(() => OAuthToken)
	gCalendar: OAuthToken = null;

	//@Deprecated
	@Type(() => OAuthToken)
	outlook365: OAuthToken = null;

	// iCalendar: Token = null;


	constructor() {
		super();
	}

	getCurrentSchemaVersion() {
		return 2
	}

	hasGoogleCalendar(){
		return this.gCalendarItemsArray.length > 0
	}

	hasOutlookCalendar(){
		return this.outlook365ItemsArray.length > 0
	}

	hasICalCalendar(){
		return this.iCalItemsArray.length > 0
	}

	getAllValidCalendarItems(){
		return [...this.getValidGCalendarItemsArray(), ...this.getValidOutlook365ItemsArray(), ...this.getValidICalItemsArray()]
	}

	getAllCalendarItems(){
		return [...this.gCalendarItemsArray, ...this.outlook365ItemsArray, ...this.iCalItemsArray]
	}

	getValidGCalendarItemsArray(){
		return this.gCalendarItemsArray.filter(this.validCalendarItemFilter.bind(this))
	}
	getValidOutlook365ItemsArray(){
		return this.outlook365ItemsArray.filter(this.validCalendarItemFilter.bind(this))
	}
	getValidICalItemsArray(){
		return this.iCalItemsArray.filter(this.validCalendarItemFilter.bind(this))
	}

	validCalendarItemFilter(calendarItem){
		return !calendarItem.isTokenRevoked
	}

	setCalendarItem(calendarItem){
		let {array, index} = this.findCalendarItemLocation(calendarItem)
		array.splice(index, 1, calendarItem)
	}

	deleteCalendarItem(calendarItem){
		let {array, index} = this.findCalendarItemLocation(calendarItem)
		let [deleted] = array.splice(index, 1)
		return deleted
	}

	findCalendarItemLocation(calendarItem){
		let array
		if(calendarItem.isGCalendar()){
			array = this.gCalendarItemsArray
		}
		if(calendarItem.isOutlookCalendar()){
			array = this.outlook365ItemsArray
		}
		if(calendarItem.isICAlCalendar()){
			array = this.iCalItemsArray
		}
		let index = array.findIndex(item => item.id === calendarItem.id)
		return {array, index}
	}



	// getReadForConflictsCalendarItems(){
	// 	let allCalendars = this.getAllCalendarItems()
	// 	let res = []
	// 	for(let calendarItem of allCalendars){
	//
	// 	}
	// 	return res
	// }
	// getReadForConflictsCalendarItems(){
	// 	return [...this.gCalendarItemsArray, ...this.outlook365ItemsArray, ...this.iCalItemsArray]
	// }

	_addCalendarUniqueInternal(destArray, calendarItem){
		let index = destArray.findIndex(item => item.calendarEmail === calendarItem.calendarEmail)
		console.log("_addCalendarUniqueInternal: index = ", index, ", calendarItem = ", calendarItem, ", destArray = ", destArray)
		if(index < 0){
			destArray.push(calendarItem)
			return true
		} else {
			//reconnecting logic - if token was revoked previously we substitute this calendar's token with a new one and reset revokation state
			let calendarItemLocal = destArray[index]
			console.log("_addCalendarUniqueInternal: calendarItemLocal = ", calendarItemLocal)
			if(calendarItemLocal.isTokenRevoked){
				calendarItemLocal.oauthToken = calendarItem.oauthToken
				calendarItemLocal.isTokenRevoked = false
				return true
			}
		}
		return false
	}

	addCalendarItem(calendarItem){
		let isCalendarTypeKnown
		let calendarAlreadyExists = false
		if(calendarItem.isOutlookCalendar()){
			calendarAlreadyExists = !this._addCalendarUniqueInternal(this.outlook365ItemsArray, calendarItem)
			isCalendarTypeKnown = true
		}
		if(calendarItem.isGCalendar()){
			calendarAlreadyExists = !this._addCalendarUniqueInternal(this.gCalendarItemsArray, calendarItem)
			isCalendarTypeKnown = true
		}
		if(calendarItem.isICAlCalendar()){
			calendarAlreadyExists = !this._addCalendarUniqueInternal(this.iCalItemsArray, calendarItem)
			isCalendarTypeKnown = true
		}
		if(!isCalendarTypeKnown){
			throw "Unknown calendar type: calendarType = " + calendarItem.calendarType
		}
		if(calendarAlreadyExists){
			return false
		}

		return true
	}

	invalidateWriteToCalendarIfNeeded(){
		let allCalendars = this.getAllValidCalendarItems()
		let hasWriteToCalendar = this.getWriteToCalendarItem() != null

		if(!hasWriteToCalendar && allCalendars.length > 0){
			allCalendars[0].setWriteToPrimarySubCalendar()
		}
	}

	resetWriteToCalendarAll(){
		let allCalendars = this.getAllCalendarItems()
		for(let calendarItem of allCalendars){
			calendarItem.resetWriteToSubCalendars()
		}
	}
	getReadFromCalendarItemArrayGoogle(){
		return this.getReadFromCalendarItemArray(this.getValidGCalendarItemsArray())
	}
	getReadFromCalendarItemArrayOutlook(){
		return this.getReadFromCalendarItemArray(this.getValidOutlook365ItemsArray())
	}
	getReadFromCalendarItemArrayICal(){
		return this.getReadFromCalendarItemArray(this.getValidICalItemsArray())
	}

	getReadFromCalendarItemArray(calendarItemsArray){
		let tokenItemArray = []
		for(let calendarItem of calendarItemsArray){
			if(calendarItem.hasReadFromSubCalendar()){
				tokenItemArray.push(calendarItem)
			}
		}
		return tokenItemArray
	}

	getWriteToCalendarItem(){
		let allCalendars = this.getAllValidCalendarItems()
		for(let calendarItem of allCalendars){
			if(calendarItem.hasWriteToSubCalendar()){
				return calendarItem
			}
		}
	}

	migrateSchema(oldVersion, newVersion) {
		super.migrateSchema(oldVersion, newVersion);
		// console.log("CalendarIntegrations.migrateSchema: schemaVersion = ", this.schemaVersion, this)
		// versionIncrement += this.downgradeSchema()
		if(oldVersion < 2){
			if(this.gCalendar){
				let calendarItem = new GoogleCalendarItem()
				calendarItem.oauthToken = this.gCalendar
				// The below woo-woo is needed because of some legacy code/logic.
				// We've switched client keys for google account after 16 January 2021 and not every object had createdAt at that time
				// those where createdAt is not set, it will be inited with "now", but it will be a few moment behind, so we account for it with a 1sec gap
				let gapNow = new Date().getTime() - 1000
				let jan16_2021_ms = 1610833015000
				let isOldKeys = this.createdAt > gapNow || this.createdAt < jan16_2021_ms
				if(isOldKeys){
					calendarItem.isOldKeys = true
				}
				this.addCalendarItem(calendarItem)
				this.gCalendar = null
			}
			if(this.outlook365){
				let calendarItem = new OutlookCalendarItem()
				calendarItem.oauthToken = this.outlook365
				this.addCalendarItem(calendarItem)
				this.outlook365 = null
			}
		}
	}


	downgradeSchema(){
		if(this.schemaVersion === 2){

			if(this.gCalendarItemsArray && this.gCalendarItemsArray.length){
				this.gCalendar = this.gCalendarItemsArray[0].oauthToken
				this.gCalendarItemsArray = []
			}
			if(this.outlook365ItemsArray && this.outlook365ItemsArray.length){
				this.outlook365 = this.outlook365ItemsArray[0].oauthToken
				this.outlook365ItemsArray = []
			}
			return -1
		}
		return 0
	}
}
